import EventEmitter from 'events';

export enum EMITTER_EVENTS {
  BODY_KEYDOWN = 'body_keydown',
}

export const eventEmitter = new EventEmitter();
// eslint-disable-next-line jest/require-hook
eventEmitter.setMaxListeners(1000); // by default 10
